// The floating AgentX button, on every page (owner 2026-10-21: "an overarching icon — when clicked, a chat box").
// Shown only when the server lets this user use AgentX (its spend endpoint answers: superusers, AGENTX_ENABLED on).
// Desktop: a chat box anchored bottom-right; phone: full screen. Hidden on the full page (/agentx) itself.
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import agentxService from '../../services/agentxService';
import AgentXChat from './AgentXChat';

export default function AgentXLauncher() {
  const [available, setAvailable] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    agentxService.getSpend().then(() => { if (alive) setAvailable(true); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!available || location.pathname.startsWith('/agentx')) return null;

  const expand = (sessionId) => {
    setOpen(false);
    navigate(sessionId ? `/agentx?c=${sessionId}` : '/agentx');
  };

  return (
    <>
      {open && (
        <div role="dialog" aria-label="AgentX"
             className="fixed z-50 inset-0 sm:inset-auto sm:bottom-24 sm:right-6 sm:w-[420px] sm:h-[640px] sm:max-h-[calc(100vh-8rem)]
                        sm:rounded-2xl overflow-hidden shadow-2xl border border-gray-200 dark:border-gray-800">
          <AgentXChat variant="panel" onClose={() => setOpen(false)} onExpand={expand} />
        </div>
      )}
      <button type="button" onClick={() => setOpen((o) => !o)}
              aria-label={open ? 'Close AgentX' : 'Open AgentX'} title="AgentX"
              className={`fixed z-50 bottom-6 right-6 h-14 w-14 rounded-full shadow-lg flex items-center justify-center
                          border border-brand-gold/60 bg-[#0d1117] text-brand-gold hover:scale-105 transition-transform
                          focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold ${open ? 'hidden sm:flex' : 'flex'}`}>
        {open ? <span className="text-xl leading-none">✕</span>
              : <span className="font-serif text-[15px] font-semibold tracking-tight">A<span className="text-[11px] align-super">X</span></span>}
      </button>
    </>
  );
}
